/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { Button } from "components/button";
import { Input } from "components/input";
// import { ErrorP } from "components/input/input.style";
import { SelectInput } from "components/select";
import { Textarea } from "components/textarea";
import { CheckBoxInput, CheckBoxLabel } from "container/update-school-form/curriculum-checkbox";
import { useNotify } from "hooks";
import { schoolEnquiry } from "services/school";
import { InputWrapper } from "styles/form";
import {
   ArtIcon,
   BallIcon,
   CodingIcon,
   CookingIcon,
   MusicIcon,
   SpeechIcon,
   StemIcon,
   SwimmingIcon,
   WritingIcon,
} from "svgs";
import {
   InputContainer,
   InterestContainer,
   InterestLabel,
   InterestPill,
   SchoolApplicationFormContainer,
   SelectedInterestContainer,
   SelectedInterestPill,
   SelectedOthersContainer,
} from "./school-application.style";

interface InterestProps {
   id: number;
   int: string;
}

export const SchoolEnquiryForm = ({ school, close }) => {
   const [isLoading, setIsLoading] = useState(false);
   const [selectedInterests, setSelectedInterests] = useState<InterestProps[]>([]);
   const [selectedOthers, setSelectedOthers] = useState<boolean>(false);

   const { notify } = useNotify();

   const schema = yup.object().shape({
      name: yup.string().required("Name is a required field"),
      email: yup.string().email().required("Email name is a required field"),
      location: yup.string().required("Location is a required field"),
      phone: yup.string().required("Phone is a required field"),
      subject: yup.string().required("Subject is a required field"),
      message: yup.string().required("Message is a required field"),
      childInterest: yup
         .array()
         .of(yup.string().required("Each interest must be a non-empty string"))
         .required("Child's interest is required")
         .min(1, "Child's interest is required"),
      loanAmount: yup
         .number()
         .min(0)
         .max(100000000)
         .nullable(true)
         .transform((_, val) => (val ? Number(val) : null)),
      willSubscribe: yup.bool().default(false),
      childAge: yup.string().required("Select Child's age"),
      childGender: yup.string().required("Select Child's gender"),
   });

   const {
      handleSubmit,
      register,
      reset,
      getValues,
      setValue,
      clearErrors,
      formState: { errors, isValid },
      control,
   } = useForm<any>({
      resolver: yupResolver(schema),
      mode: "onChange",
   });

   async function submit(values: Record<string, string>) {
      try {
         setIsLoading(true);
         await schoolEnquiry(school.id, {
            ...values,
         });
         notify({
            message: "Success",
            variant: "success",
         });
         close();
         reset();
         setSelectedOthers(false);
         setSelectedInterests([])
      } catch (err: any) {
         notify({
            message: err.result.message || err.result.custom_message,
            variant: "error",
         });
      } finally {
         setIsLoading(false);
      }
   }

   const genderOptions = [
      { label: "MALE", value: "male" },
      { label: "FEMALE", value: "female" },
   ];

   const interests = [
      { id: 1, int: "Music" },
      { id: 2, int: "Swimming" },
      { id: 3, int: "Cooking" },
      { id: 4, int: "Soccer" },
      { id: 5, int: "Stem" },
      { id: 6, int: "Speaking" },
      { id: 7, int: "Art" },
      { id: 8, int: "Writing" },
      { id: 9, int: "Coding" },
      { id: 10, int: "Others" },
   ];

   const iconMapping = {
      1: (props) => <MusicIcon {...props} />,
      2: (props) => <SwimmingIcon {...props} />,
      3: (props) => <CookingIcon {...props} />,
      4: (props) => <BallIcon {...props} />,
      5: (props) => <StemIcon {...props} />,
      6: (props) => <SpeechIcon {...props} />,
      7: (props) => <ArtIcon {...props} />,
      8: (props) => <WritingIcon {...props} />,
      9: (props) => <CodingIcon {...props} />,
   };

   const addInterest = (newInterest) => {
      clearErrors("childInterest");
      // Check if the interest already exists
      setSelectedInterests((prevInterests) => {
         const exists = prevInterests?.some((item) => item.id === newInterest.id);
         if (!exists) {
            return [...prevInterests, newInterest];
         }
         return prevInterests; // No change if it already exists
      });
   };

   const removeInterest = (interestId) => {
      setSelectedInterests((prevInterests) => {
         const updatedInterests = prevInterests.filter((item) => item.id !== interestId);
         setValue("childInterest", updatedInterests);

         return updatedInterests;
      });
   };

   const handleInterestClick = (newInterest) => {
      const sentInterests = getValues("childInterest") || [];
      if (selectedInterests.some((interest) => interest.id === 10)) {
         return;
      }
      if (newInterest?.id === 10) {
         setSelectedOthers(true);
         setSelectedInterests([newInterest]);
      } else {
         setValue("childInterest", [...sentInterests, newInterest?.int]);
         addInterest(newInterest);
      }
   };

   const ageOptions = [
      { label: "0 years", value: "0" },
      { label: "1 years", value: "1" },
      { label: "2 years", value: "2" },
      { label: "3 years", value: "3" },
      { label: "4 years", value: "4" },
      { label: "5 years", value: "5" },
      { label: "6 years", value: "6" },
      { label: "7 years", value: "7" },
      { label: "8 years", value: "8" },
      { label: "9 years", value: "9" },
      { label: "10 years", value: "10" },
      { label: "11 years", value: "11" },
      { label: "12 years", value: "12" },
      { label: "13 years", value: "13" },
      { label: "14 years", value: "14" },
      { label: "15 years", value: "15" },
      { label: "16 years", value: "16" },
      { label: "17 years", value: "17" },
      { label: "18 years", value: "18" },
   ];

   const handleInterestInputChange = (e) => {
      const inputValue = e.target.value;
      const interests = inputValue
         .split(",")
         .map((item) => item.trim())
         .filter((item) => item.length > 0);

      // Update the form value
      setValue("childInterest", interests, { shouldValidate: true });
   };

   return (
      <SchoolApplicationFormContainer>
         <div
            style={{
               display: "flex",
               justifyContent: "center",
            }}
         >
            <h3 className="title">{school?.name}</h3>
         </div>
         <p className="brief">
            Got a question? Drop your message below. We will get back to you sooner than you think.
         </p>

         <form onSubmit={handleSubmit(submit)}>
            <InputWrapper className="grid-2-2 mt-15">
               <Input
                  label="Full name"
                  placeholder="Enter full name"
                  required
                  id="name"
                  type="text"
                  {...register("name")}
                  error={errors.name?.message}
               />
               <Input
                  label="Email address"
                  placeholder="Enter your email"
                  required
                  id="email"
                  type="text"
                  {...register("email")}
                  error={errors.email?.message}
               />
            </InputWrapper>
            <InputWrapper className="grid-2-2 mt-15">
               <Input
                  label="Phone number"
                  placeholder="Enter your phone number"
                  required
                  id="phone"
                  type="number"
                  {...register("phone")}
                  error={errors.phone?.message}
               />
               <Input
                  label="Location"
                  placeholder="Enter your location"
                  required
                  id="location"
                  type="text"
                  {...register("location")}
                  error={errors.location?.message}
               />
            </InputWrapper>
            <InputWrapper className="grid-2-2 mt-15">
               <Controller
                  control={control}
                  name="childGender"
                  render={({ field: { onChange } }) => (
                     <SelectInput
                        isClearable
                        placeholder="Select Child's gender"
                        label="Select child’s gender"
                        onChange={(val: any) => {
                           onChange(val?.value);
                        }}
                        options={genderOptions}
                        error={errors.childGender?.message}
                        required
                     />
                  )}
               />

               <Controller
                  control={control}
                  name="childAge"
                  render={({ field: { onChange } }) => (
                     <SelectInput
                        isClearable
                        placeholder="Select Child's age"
                        label="How old is your child"
                        onChange={(val: any) => {
                           onChange(val?.value);
                        }}
                        options={ageOptions}
                        error={errors.childAge?.message}
                        required
                     />
                  )}
               />
            </InputWrapper>
            <InputWrapper>
               <Input
                  label="Subject of enquiry"
                  placeholder="Enter subject of enquiry"
                  required
                  id="subject"
                  type="text"
                  {...register("subject")}
                  error={errors.subject?.message}
               />
            </InputWrapper>
            {selectedOthers ? (
               <div>
                  <InterestLabel>
                     Kindly select your child’s interest/passion(separate each interest with a
                     comma) <span style={{ color: "red" }}>*</span>
                  </InterestLabel>
                  <div style={{ width: "100%", display: "flex", flexWrap: "wrap", gap: "10px" }}>
                     <SelectedOthersContainer>
                        <SelectedInterestPill
                           onClick={() => {
                              setSelectedOthers(false);
                              setSelectedInterests([]);
                           }}
                           activeColor="#264FFA"
                        >
                           <p>Others</p> <p style={{ fontSize: "12px" }}>X</p>
                        </SelectedInterestPill>
                     </SelectedOthersContainer>
                     <InputContainer>
                        <Input
                           placeholder="separate each interest with a comma"
                           required
                           id="input-interest"
                           type="text"
                           onChange={handleInterestInputChange}
                           error={errors.childInterest?.message}
                        />
                     </InputContainer>
                  </div>
               </div>
            ) : (
               <>
                  <InterestLabel>
                     Kindly select your child’s interest/passion{" "}
                     <span style={{ color: "red" }}>*</span>
                  </InterestLabel>
                  <SelectedInterestContainer
                     padding={selectedInterests?.length > 0 ? "10px" : "25px"}
                  >
                     <InterestContainer>
                        {selectedInterests?.map((interest, idx) => {
                           const Icon = iconMapping[interest?.id];
                           return (
                              <SelectedInterestPill activeColor="#264FFA" key={idx}>
                                 {Icon ? <Icon color="#264FFA" /> : null}
                                 <p>{interest?.int}</p>{" "}
                                 <p
                                    onClick={() => removeInterest(interest?.id)}
                                    style={{ fontSize: "12px" }}
                                 >
                                    X
                                 </p>
                              </SelectedInterestPill>
                           );
                        })}
                     </InterestContainer>
                  </SelectedInterestContainer>
               </>
            )}
            <InterestContainer>
               {interests?.map((interest, idx) => {
                  const Icon = iconMapping[interest?.id];
                  const isActive = selectedInterests.some(
                     (selectedInterest) => selectedInterest.id === interest?.id
                  );
                  return (
                     <InterestPill activeColor={isActive ? "#264FFA" : undefined} key={idx}>
                        {Icon ? <Icon color={isActive ? "#264FFA" : "#666666"} /> : null}
                        <p onClick={() => handleInterestClick(interest)}>{interest?.int}</p>{" "}
                        {isActive && (
                           <p
                              onClick={() => {
                                 if (interest?.id === 10) {
                                    removeInterest(interest?.id);
                                    setSelectedOthers(false);
                                 } else {
                                    removeInterest(interest?.id);
                                 }
                              }}
                              style={{ fontSize: "12px" }}
                           >
                              X
                           </p>
                        )}
                     </InterestPill>
                  );
               })}
               <p className="error-p">{errors.childInterest?.message}</p>
            </InterestContainer>
            <InputWrapper>
               <Textarea
                  label="Message"
                  placeholder="Your message"
                  required
                  id="message"
                  {...register("message")}
                  error={errors.message?.message}
               />
            </InputWrapper>
            <InputWrapper className="grid-2-2 mt-15">
               <div>
                  <p style={{ fontSize: "13px" }}>
                     Need loan for school fees or to buy Learning materials? (
                     <span style={{ color: "#3578E5" }}>No paperwork or collateral required</span>)
                  </p>
                  <Input
                     id="loanAmount"
                     placeholder="Enter loan amount"
                     type="number"
                     {...register("loanAmount")}
                     error={errors.loanAmount?.message}
                     startAdornment="₦"
                  />
               </div>
               <div style={{ marginTop: "10px" }}>
                  <CheckBoxInput
                     id="willSubscribe"
                     type="checkbox"
                     {...register("willSubscribe")}
                     name="willSubscribe"
                  />
                  <CheckBoxLabel htmlFor="willSubscribe">
                     Would you be happy to subscribe to any plan to ensure your child’s education
                     continue incase of any eventuality?
                  </CheckBoxLabel>
                  {/* <ErrorP className="error-text">{errors.tandc && errors.willSubscribe?.message}</ErrorP> */}
               </div>
            </InputWrapper>

            <div className="btn-div">
               <Button
                  disabled={isLoading || !isValid}
                  type="submit"
                  variant="primary"
                  isLoading={isLoading}
               >
                  Submit
               </Button>
            </div>
         </form>
      </SchoolApplicationFormContainer>
   );
};
